export function isRevSharePctConfigured(value) {
  return value != null && value !== '' && Number.isFinite(Number(value));
}

export function resolveProRataRevSharePct(actualFundingPct) {
  const pct = Number(actualFundingPct);
  if (!Number.isFinite(pct) || pct <= 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, pct));
}

export function resolveActualFundingPct(marketing, drawAmount) {
  const spend = Number(marketing) || 0;
  const draw = Number(drawAmount) || 0;
  if (spend <= 0 || draw <= 0) {
    return 0;
  }
  return Math.min(100, (draw / spend) * 100);
}

export function resolveEffectiveRevSharePctFromParts({
  configuredRevSharePct,
  actualFundingPct,
  fallbackFundingPct = 0,
}) {
  if (isRevSharePctConfigured(configuredRevSharePct)) {
    return Number(configuredRevSharePct);
  }
  if (actualFundingPct != null) {
    return resolveProRataRevSharePct(actualFundingPct);
  }
  return resolveProRataRevSharePct(fallbackFundingPct);
}

export const PRO_RATA_REV_SHARE_TOOLTIP =
  'Optional. When empty, repayment uses pro-rata revenue share: the same % as actual funding for that cohort (e.g. fund 60% of marketing → collect up to 60% of net revenue). If covenants reduce the draw below the max funding %, the charge follows the actual funded amount. When set, always use this % of net revenue (still capped by outstanding balance).';
